<div class="flex flex-col max-w-240 md:min-w-160 max-h-screen -m-6 dms-modal" 
    >

    <!-- Header -->
    <div class="flex flex-0 items-center justify-between h-16 pr-3 sm:pr-5 pl-6 sm:pl-8 bg-primary text-on-primary">
        <!-- Group for icon and title -->
        <div class="flex items-center">
            <mat-icon class="text-current mr-2" [svgIcon]="'mat_outline:file_copy'"></mat-icon>
            <div class="text-lg font-medium">Duplicate File Found</div>
        </div>

        <!-- Close button on the far right -->
        <button mat-icon-button (click)="cancelAll()" [tabIndex]="-1">
            <mat-icon class="text-current" [svgIcon]="'heroicons_outline:x-mark'"></mat-icon>
        </button>
    </div>

    <!-- Compose form -->
    <form *ngIf="data?.existingFiles?.length==1" class="flex flex-col flex-auto p-6 sm:p-8 overflow-y-auto">
       <div class="mb-4">
            <div class="text-on-surface mt-2">A file with the same name <strong>[{{ data.item.file.name }}]</strong> already exists in this location. <br><br>What would you like to do?</div>
       </div>

       <div class="flex flex-col sm:flex-row sm:items-center justify-between mt-4 sm:mt-6">
            <div class="flex w-full justify-between mt-5 sm:mt-0">
                <button mat-stroked-button (click)="cancelAll()">
                    Cancel
                </button>
                <button [color]="'primary'" mat-stroked-button (click)="dup_copy()">
                    Create a copy
                </button>
                <button [color]="'warn'" mat-flat-button (click)="dup_overwrite()">
                    Overwrite file
                </button>
            </div>
        </div>

    </form>

     <!-- Compose form -->
    <form *ngIf="data.existingFiles.length>1" class="flex flex-col flex-auto p-6 sm:p-8 overflow-y-auto">
        <div class="mb-4">
            <div class="text-on-surface mt-2 text-clip">{{data.existingFiles.length}} items already exist in this location.
                <br><br>What would you like to do?</div>
        </div>
    
        <div class="flex flex-col gap-4 sm:flex-row sm:items-center justify-between mt-4 sm:mt-6">
            <mat-radio-group class="" name="existFileOption" (change)="onOptionChangeForAll($event)"
                [(ngModel)]="existFileOptions" #planRadioGroup="matRadioGroup">
    
                <mat-radio-button [value]="'copy'">Create a copy</mat-radio-button>
                <mat-radio-button [value]="'replace'">Overwrite</mat-radio-button>
                <mat-radio-button [value]="'file-specific'">File-Specific Options</mat-radio-button>
            </mat-radio-group>
    
        </div>
        <div class="flex flex-col" *ngIf="existFileOptions=='file-specific'">
            <div *ngFor="let item of data.existingFiles">
                <div class="flex items-center justify-between p-4 border-b">
                    <span class="text-lg">{{item.file.name}}</span>
                    <div class="flex ms-auto space-x-4">
                        <mat-radio-group class="" [attr.name]="'selectedExitOption'+item.file.name"
                            (change)="onOptionChange($event,item)" #planRadioGroup="matRadioGroup">
    
                            <mat-radio-button [checked]="true" [value]="'cancel'">Skip</mat-radio-button>
                            <mat-radio-button [value]="'copy'">Duplicate</mat-radio-button>
                            <mat-radio-button [value]="'replace'">Overwrite</mat-radio-button>
                        </mat-radio-group>
                    </div>
                </div>
            </div>
        </div>
        <!-- Actions -->
        <ng-container>
            <div class="flex items-center justify-center sm:justify-end px-6 py-4 space-x-3">
    
                <!-- Cancel -->
                <ng-container>
                    <button mat-stroked-button (click)="cancelAll()">
                        Cancel
                    </button>
                </ng-container>
    
                <!-- Confirm -->
                <ng-container>
                    <button mat-flat-button [color]="'primary'" [disabled]="isAllSkipped()" (click)="uploadFiles()">
                        Upload
                    </button>
                </ng-container>
    
            </div>
        </ng-container>
    </form>
</div>